import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';

import { get } from '../utils/httpRequests';
import { APIs } from '../utils/apis';

const TrackingServer = () => {
  const [state, setState] = useState();
  useEffect(() => {
    get({ url: APIs.TRACKING_HEALTH })
      .then(response => {
        if (response?.data?.metaCode === 200) {
          setState('Page is healthy');
        } else {
          setState('Page is not healthy');
        }
      })
      .catch(() => {
        setState('Page is not healthy');
      });
  }, []);

  return (
    <Row>
      <Col span={24}>
        <h2>{state}</h2>
      </Col>
    </Row>
  );
};

export default TrackingServer;
